<div class="reveal-overlay bsc-modal">
  <div role="dialog" class="reveal">
    <ng-content></ng-content>
  </div>
</div>